import React from 'react';
import titleCase from '@gumtree/shared/src/util/title-case';

import { MotorsAttribute, CommonAttribute } from '@gumtree/shared/src/types/attributes';
import { VipState } from '../../reducers';
import { Container, AttributesValue, AttributesColumn, AttributesRow } from './index.style';

export const removePostedDate = (attributes: (MotorsAttribute | CommonAttribute)[]) => {
    return attributes.filter((attrib) => attrib.key !== 'Posted');
};

const Attributes = ({
    isMobileCardsLayout = false,
    attributes,
    l1CategorySeoName,
    children,
}: {
    attributes: VipState['adDetails']['attributes'];
    isMobileCardsLayout?: boolean;
    l1CategorySeoName: VipState['adDetails']['l1CategorySeoName'];
    children?: React.ReactNode;
}) => {
    /**
     * For Motors VIPs where detailed `MotorsAttributes` are available,
     * we only show restricted attributes here. In particular,
     * `commonAttributes` may only have `Seller Type` and `Posted`.
     */
    const rawAttributes =
        'commonAttributes' in attributes ? attributes.commonAttributes : attributes;
    const isMotors = l1CategorySeoName === 'cars-vans-motorbikes';
    const isServices = l1CategorySeoName === 'business-services';
    const attributesProcessed = isServices ? removePostedDate(rawAttributes) : rawAttributes;

    if (attributesProcessed.length === 0) {
        return <></>;
    }

    return (
        <Container
            data-q="attribute-container"
            isMobileCardsLayout={isMobileCardsLayout}
            isMotors={isMotors}
            isSingleAttr={attributesProcessed?.length <= 1}
        >
            {(attributesProcessed as (MotorsAttribute | CommonAttribute)[]).map((attrib) => (
                <AttributesRow
                    key={attrib.name}
                    data-q="attribute-row"
                    isMobileCardsLayout={isMobileCardsLayout}
                >
                    <AttributesColumn data-q="car-header-attribute">
                        {titleCase(attrib.name)}
                    </AttributesColumn>
                    <AttributesValue
                        data-testid="attribute-value"
                        isMobileCardsLayout={isMobileCardsLayout || isMotors}
                        className="attributes-column attributes-value"
                        itemProp={'itemProp' in attrib ? attrib.itemProp : undefined}
                        data-q={`${attrib.name}-value`}
                    >
                        {attrib.value}
                        {attrib.unit && ` ${attrib.unit}`}
                    </AttributesValue>
                </AttributesRow>
            ))}
            {children}
        </Container>
    );
};

export default Attributes;
